/* ============================================================================
   ADMIN → FORMULAS — DATA CONTOH (PROTOTAIP DESIGN · 27 Okt 2026)
   ============================================================================
   Arahan user: "kau terus buat ui design dulu tanpa wired apa-apa or pindahkan code apa2 dari
   workspace sebenar" + "pastikan tak ada yg hilang setting dalam setiap setting dlm tiap module".
   Semua di bawah = CONTOH RUPA. Tiada Firestore, tiada peti besi, tiada master prompt sebenar.
   "Formula" = nama skrin baharu untuk module (data kekal `modules`).

   ⭐ PARITI dengan popup Module Settings sedia ada (App.jsx ~8076–9080) + Create module + medan tanpa UI
      — inventori penuh 27 Okt. Setiap medan sedia ada ada tempat dalam editor baharu:
      General (nama, ID, enjin, ikon, warna, akses, status keluaran, susunan, penerangan, padam) ·
      Card (kadNotaMs/En, kadBadge, kadDurasi, kadGoal, kadFormat, kadPil, poster/video) ·
      Prompt (3 mode master prompt / block, Wajib Append imej + video, Scene 2 + prepend, sub-module) ·
      Customer options (kadScenes + pilihan baharu) · Robot (enjin + workflow) ·
      Extras (GOYANG fragment + system template · SMART ChatGPT template · FLOWNITY scrape agent) ·
      History (arkib private/history_*, kiraan aksara Mode 1/2/3, Pulih isi borang sahaja).
   ========================================================================== */

export const STATUS_FA = {
    open: { label: 'Open', tone: 'ok' },
    admin: { label: 'Admin only', tone: 'neutral' },
    draft: { label: 'Draft', tone: 'warn' },
};

/* Akses awal = adminOnly / isPremiumAddon (Create module "Akses awal"). */
export const AKSES_FA = [
    { id: 'admin', label: 'Admin only (testing)' },
    { id: 'paid', label: 'All paid customers' },
    { id: 'addon', label: 'Premium add-on' },
];
/* Enjin = scriptKey + promptSchema (ENGINE_PRESETS Create module). Tetap selepas cipta. */
export const ENJIN_FA = {
    flow1: 'Flow 1 scene (AI8SAAT robot)',
    flow2: 'Flow 2 scenes (AI16SAAT robot)',
    nscene: 'Flow N-scene (FLOWNITY robot)',
    resipi: 'Flow Multi-Scene — Flow Resipi',
    goyang: 'GOYANG motion template',
    smart: 'SMART — follows agent scene count',
    manual: 'Manual (no automation)',
};

/* 3 mode master prompt — label SAMA seperti utils/promptResolver.js MODE_LABELS (KEMBAR rupa). */
export const MOD_PROMPT = [
    { id: 'mode1', label: 'No avatar · no gender' },
    { id: 'mode2', label: 'No avatar · pick gender' },
    { id: 'mode3', label: 'With avatar + gender' },
];
export const PEMEGANG_TEMPAT = ['{{pronoun}}', '{{pronoun_lower}}', '{{gender}}', '{{avatar_age}}', '{{avatar_hijab}}'];

export const FORMULA_CONTOH = [
    { id: 'ai8saat', nama: 'AI8SAAT', nota: 'Hold product · 1 scene', notaMs: '1 scene · 3 set', notaEn: '1 scene · 3 sets', badge: '', durasi: '0:08', goal: 'sell', format: 'video', pil: 'HOLD', status: 'open', akses: 'paid', mod: 'classic', enjin: 'flow1', ikon: 'bolt', warna: '#6366f1', susunan: 1, poster: '/salespage/thumbs/ai8saat.avif' },
    { id: 'ai16saat-half', nama: 'AI16SAAT', nota: 'Hold product · 2 scenes', notaMs: '2 scene · 3 set', notaEn: '2 scenes · 3 sets', badge: '', durasi: '0:16', goal: 'sell', format: 'video', pil: 'HOLD', status: 'open', akses: 'paid', mod: 'classic', enjin: 'flow2', duaScene: true, ikon: 'movie', warna: '#0ea5e9', susunan: 2, poster: '/salespage/thumbs/ai16saat.avif' },
    { id: 'homeniche', nama: 'HOME NICHE', nota: 'Home demo · 2 scenes', notaMs: 'Demo rumah · 2 scene', notaEn: 'Home demo · 2 scenes', badge: '', durasi: '0:16', goal: 'sell', format: 'video', pil: 'DEMO', status: 'open', akses: 'paid', mod: 'classic', enjin: 'flow2', duaScene: true, ikon: 'home', warna: '#10b981', susunan: 3, poster: '/salespage/thumbs/homeniche.avif' },
    { id: 'goyang', nama: 'GOYANG', nota: 'Motion template', notaMs: 'Template gerakan', notaEn: 'Motion template', badge: '', durasi: '0:08', goal: 'sell', format: 'video', pil: 'HOLD', status: 'open', akses: 'paid', mod: 'classic', enjin: 'goyang', extras: 'goyang', ikon: 'animation', warna: '#f59e0b', susunan: 4, poster: '/salespage/thumbs/goyang.avif' },
    { id: 'smartcustom', nama: 'SMART', nota: 'Your own GPT / Gem agent', notaMs: 'Agent GPT / Gem anda', notaEn: 'Your own GPT / Gem agent', badge: '', durasi: '0:08', goal: 'sell', format: 'video', pil: '', status: 'open', akses: 'addon', mod: 'classic', enjin: 'smart', extras: 'smart', ikon: 'smart_toy', warna: '#8b5cf6', susunan: 5, poster: '/salespage/thumbs/smartcustom.avif', tiadaDoc: true },
    { id: 'flownity', nama: 'FLOWNITY', nota: 'New image every scene', notaMs: 'Gambar baru setiap scene', notaEn: 'New image every scene', badge: 'NEW', durasi: '0:40', goal: 'sell', format: 'video', pil: '', status: 'open', akses: 'addon', mod: 'classic', enjin: 'nscene', extras: 'flownity', ikon: 'auto_awesome', warna: '#ec4899', susunan: 6, poster: '/salespage/thumbs/flownity.avif', subModul: true },
    { id: 'kitchen-demo', nama: 'Kitchen Demo', nota: 'Real kitchen counter demo', notaMs: 'Demo kaunter dapur', notaEn: 'Real kitchen counter demo', badge: 'BETA', durasi: '0:24', goal: 'sell', format: 'video', pil: 'DEMO', status: 'admin', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'kitchen', warna: '#6366f1', susunan: 7 },
    { id: 'fashion-tryon', nama: 'Fashion Try-On', nota: 'Model wears the product', notaMs: 'Model pakai produk', notaEn: 'Model wears the product', badge: 'BETA', durasi: '0:16', goal: 'sell', format: 'video', pil: '', status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'checkroom', warna: '#6366f1', susunan: 8 },
    { id: 'caption-jualan', nama: 'Caption Jualan', nota: 'Caption, script, hashtags to copy', notaMs: 'Caption, skrip, hashtag untuk copy', notaEn: 'Caption, script, hashtags to copy', badge: '', durasi: '', goal: 'sell', format: 'text', pil: '', status: 'admin', akses: 'admin', mod: 'blocks', enjin: 'manual', ikon: 'notes', warna: '#64748b', susunan: 9 },
    { id: 'photo-refine', nama: 'Product Photo Refine', nota: 'Clean up your own product photo', notaMs: 'Kemaskan gambar produk anda', notaEn: 'Clean up your own product photo', badge: '', durasi: '', goal: 'sell', format: 'image', pil: '', status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'image', warna: '#64748b', susunan: 10 },
    { id: 'warm-up', nama: 'Warm Up Harian', nota: 'Daily non-selling video', notaMs: 'Video harian tanpa jual', notaEn: 'Daily non-selling video', badge: '', durasi: '0:08', goal: 'grow', format: 'video', pil: '', status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'trending_up', warna: '#64748b', susunan: 11 },
    { id: 'post-ideas', nama: 'Daily Post Ideas', nota: 'Text posts that grow followers', notaMs: 'Post teks tambah follower', notaEn: 'Text posts that grow followers', badge: '', durasi: '', goal: 'grow', format: 'text', pil: '', status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'manual', ikon: 'lightbulb', warna: '#64748b', susunan: 12 },
    { id: 'yt-thumbnail', nama: 'YouTube Thumbnail', nota: 'Click-worthy thumbnail image', notaMs: 'Thumbnail YouTube', notaEn: 'Click-worthy thumbnail image', badge: '', durasi: '', goal: 'earn', format: 'image', pil: '', status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'smart_display', warna: '#64748b', susunan: 13 },
    { id: 'faceless-story', nama: 'Faceless Story', nota: 'Long watch-time story video', notaMs: 'Video cerita tanpa muka', notaEn: 'Long watch-time story video', badge: '', durasi: '0:40', goal: 'earn', format: 'video', pil: '', status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'auto_stories', warna: '#64748b', susunan: 14 },
];

/* Library block — SATU salinan untuk semua formula. `untuk` = format yang memakai block itu.
   `tigaMod` = block yang membawa 3 versi ikut avatar/gender (ganti "Master Prompt — 3 Mode" lama). */
export const BLOCK_LIBRARY = [
    {
        id: 'quality', nama: 'Quality rules', nota: 'Accurate product, honest claims, natural Malay',
        untuk: ['video', 'image', 'text'],
        teks: 'Show only what is visible in the product photo. Never invent features, discounts or results. Write in natural Malaysian Malay, the way a real shopper talks.',
    },
    {
        id: 'goal', nama: 'Goal', nota: 'Sell / Grow / Earn objective',
        untuk: ['video', 'image', 'text'],
        teksIkutGoal: {
            sell: 'The viewer must understand the product and tap the yellow basket. A video that entertains but does not sell has failed.',
            grow: 'Do not sell. Make content people want to follow, comment on and share, so the account grows.',
            earn: 'Keep people watching until the end. Long watch time matters more than a quick sale.',
        },
    },
    {
        id: 'category', nama: 'Product category', nota: 'What matters for this kind of product',
        untuk: ['video', 'image', 'text'],
        teks: 'Kitchen products: show real size on a counter, a real food or drink, and the moment it makes cooking easier.',
    },
    {
        id: 'avatar', nama: 'Avatar & gender', nota: '3 versions: no avatar · gender · avatar', tigaMod: true,
        untuk: ['video', 'image'],
        teksIkutMod: {
            mode1: 'No person is described. Use hands only or a neutral presenter.',
            mode2: 'The presenter is a {{gender}}. Refer to them as {{pronoun_lower}}.',
            mode3: 'The presenter is the attached avatar: a {{avatar_age}} {{gender}}, {{avatar_hijab}}. Keep the face the same in every scene.',
        },
    },
    {
        id: 'storyline', nama: 'Storyline', nota: 'How the story flows (was "Story Formula")',
        untuk: ['video', 'text'],
        teks: 'Problem → solution: open with a daily problem the buyer knows, show the product fixing it, end with the result.',
    },
    {
        id: 'style', nama: 'Presentation style', nota: 'Camera, people, lighting',
        untuk: ['video', 'image'],
        teks: 'POV hands only, smartphone UGC look, natural daylight, close shots of the product in use.',
    },
    {
        id: 'hook', nama: 'Hook types', nota: 'How the first seconds grab attention',
        untuk: ['video', 'text'],
        teks: 'Write 3 different hooks. Use the hook types allowed for this formula. Never repeat the same opening words.',
    },
    {
        id: 'voiceover', nama: 'Voiceover', nota: 'Spoken lines for the video',
        untuk: ['video'],
        teks: 'Short, excited voiceover lines in Malay. One idea per line. No robotic phrasing.',
    },
    {
        id: 'imageedit', nama: 'Image refine rules', nota: 'When the customer brings their own photo',
        untuk: ['image'],
        teks: 'Keep the product exactly as in the uploaded photo. Only change the background, light and framing.',
    },
    {
        id: 'customer', nama: 'Customer extra prompt', nota: 'Short note typed by the customer',
        untuk: ['video', 'image', 'text'],
        teks: 'Follow the customer note below when it does not break the quality rules.',
    },
    {
        id: 'scene', nama: 'Scene planner', nota: 'Spreads the story over 1–5 scenes', kunci: true,
        untuk: ['video'],
        teks: 'Plan exactly the requested number of scenes. Each scene is 8 seconds. Keep the product and person the same across scenes.',
    },
    {
        id: 'adapter', nama: 'Video model', nota: 'Veo / Omni wording rules', kunci: true,
        untuk: ['video'],
        teks: 'Write video prompts the selected model can follow: at most 3 camera moves per scene.',
    },
    {
        id: 'output', nama: 'Output shape', nota: 'Fields the card and robot need', kunci: true,
        untuk: ['video', 'image', 'text'],
        teksIkutFormat: {
            video: 'Return JSON: hooks, then for each scene an image_prompt and a video_prompt, then caption and CTA.',
            image: 'Return JSON: image_prompt for each requested image, plus a short caption.',
            text: 'Return JSON: 3 hooks, a full script, a caption and hashtags — ready to copy into TikTok.',
        },
    },
];

/* Tetapan contoh per formula — block yang Custom / OFF. Selebihnya = Shared + ON. */
export const TETAPAN_BLOCK_CONTOH = {
    'kitchen-demo': {
        category: { mod: 'custom', teks: 'Always on a real Malaysian kitchen counter. Show a familiar dish (nasi goreng, teh tarik) being made faster with the product.' },
        voiceover: { on: false },
    },
    'caption-jualan': {
        hook: { mod: 'custom', teks: 'Open with a price or a question. Keep each hook under 10 words.' },
    },
};

/* Wajib Append — teks DITAMBAH SELEPAS AI (bukan dihantar ke OpenAI; kos sifar). Contoh rupa. */
export const APPEND_CONTOH = {
    imej: '- Text overlay MUST be at the TOP of the image, above the model\'s head. Never cover the face or body.\n- Large, eye-catching Bahasa Melayu (Malaysia) text.',
    video: 'Tone: fast-paced, high-energy, confident TikTok selling tone. All lines spoken fully within 8 seconds. The model smiles and speaks Bahasa Melayu (Malaysia).',
    video2: 'Scene 2: the model holds the product closer to the camera and ends with a clear call to tap the yellow basket.',
    prepend2: 'Continue from the exact last frame of scene 1. Same person, same outfit, same room.',
};

export const SUB_MODUL_CONTOH = [
    { id: 'sm_a1b2c3', nama: 'Lifestyle', prompt: 'Variation: show the product in a calm daily-life moment…' },
    { id: 'sm_d4e5f6', nama: 'Demo', prompt: 'Variation: focus on the product working, step by step…' },
    { id: 'sm_g7h8i9', nama: 'Review', prompt: 'Variation: an honest first-impression review…' },
];

/* Extras ikut formula — rupa bahagian khas sedia ada (masih simpan sendiri, bukan "Save"). */
export const EXTRAS_CONTOH = {
    goyang: {
        hooks: [
            { nama: 'Price shock', pratonton: 'Open with the price struck through and the new price…', contoh: 4, sorok: false },
            { nama: 'POV problem', pratonton: 'POV: you have this daily problem and…', contoh: 3, sorok: false },
            { nama: 'Old hook 2025', pratonton: 'Do you know this trick…', contoh: 2, sorok: true },
        ],
        bg: [
            { nama: 'Kitchen counter', pratonton: 'Clean Malaysian kitchen counter, morning light…', contoh: 3, sorok: false },
            { nama: 'Bedroom vanity', pratonton: 'Bedroom vanity table with soft lamp…', contoh: 2, sorok: false },
        ],
        template: [
            { nama: 'Raya Promo', set: ['Price shock · Kitchen counter', 'POV problem · Auto', 'Auto · Bedroom vanity'], tangan: 'Female', bgSendiri: false },
            { nama: 'Daily Sell', set: ['Auto · Auto', 'Auto · Auto', 'Auto · Auto'], tangan: 'Auto', bgSendiri: true },
        ],
    },
    smart: [
        { nama: 'Seller Pro GPT', url: 'https://chatgpt.com/g/…', scene: 1, mapping: true },
        { nama: 'Story 2 Scene Gem', url: 'https://gemini.google.com/gem/…', scene: 2, mapping: true },
    ],
    flownity: {
        chatgpt: { url: 'https://chatgpt.com/g/…', nama: 'FLOWNITY Scrape', ayat: 'Analyse this product: {productName} {productLink}', mapping: true },
        gemini: { url: '', nama: '', ayat: '', mapping: false },
    },
};

export const PILIHAN_CUSTOMER = {
    storyline: ['Problem → solution', 'Before & after', 'Product demo', 'Unboxing', 'Daily routine', 'Comparison'],
    style: ['POV hands only', 'UGC talking head', 'Cinematic showcase', 'Model showcase', 'Macro detail'],
    hook: ['Question', 'Shock / surprise', 'Price drop', 'POV', 'Problem', 'Before & after'],
    model: ['Veo 3.1 Lite LP', 'Omni Flash'],
};

/* Robot workflow — senarai SAMA rupa dengan page /workflow (contoh, bukan dibaca dari Firestore). */
export const ROBOT_CONTOH = {
    video: ['AI image to video, 1 scene', 'AI image to video, 2 scenes', 'One image, many scenes', 'New image every scene', 'Video from card images', 'Text to video'],
    image: ['Images only (Flow)', 'Refine card image (Flow)'],
    text: [],
};

export const PRODUK_UJIAN_CONTOH = ['Pengisar Mini USB', 'Tudung Bawal Satin', 'Botol Air 1L'];

export const SEJARAH_CONTOH = [
    { versi: 3, bila: '27 Oct 2026 · 10:42', siapa: 'masterzuheir@gmail.com', nota: 'Category block → Custom', aksara: [4120, 4380, 4710] },
    { versi: 2, bila: '25 Oct 2026 · 21:15', siapa: 'masterzuheir@gmail.com', nota: 'Voiceover OFF', aksara: [4120, 4380, 4650] },
    { versi: 1, bila: '24 Oct 2026 · 09:03', siapa: 'masterzuheir@gmail.com', nota: 'Created', aksara: [3980, 0, 0] },
];

/** Teks block yang berkesan untuk satu formula (Shared ikut goal/format/mod, atau Custom). */
export function teksBlock(block, formula, tetapan, modId = 'mode1') {
    if (tetapan?.mod === 'custom' && !block.kunci) {
        if (block.tigaMod) return tetapan.teksMod?.[modId] ?? block.teksIkutMod[modId];
        return tetapan.teks ?? '';
    }
    if (block.teksIkutMod) return block.teksIkutMod[modId] || '';
    if (block.teksIkutGoal) return block.teksIkutGoal[formula.goal] || block.teksIkutGoal.sell;
    if (block.teksIkutFormat) return block.teksIkutFormat[formula.format] || '';
    return block.teks || '';
}

/** Block yang terpakai untuk format formula ini (ikut susunan library). */
export const blockUntukFormat = (format) => BLOCK_LIBRARY.filter((b) => b.untuk.includes(format));

export const FORMULA_BARU = {
    id: 'baru', nama: '', nota: '', notaMs: '', notaEn: '', badge: '', durasi: '', goal: 'sell', format: 'video', pil: '',
    status: 'draft', akses: 'admin', mod: 'blocks', enjin: 'resipi', ikon: 'auto_awesome', warna: '#6366f1', susunan: 15,
};
